import DateRangeSelect from "./DateRangeSelect";

const Analytics = (props) => {
  const {
    analyticsStartDate,
    analyticsStartEnd,
    setAnalyticsStartDate,
    setAnalyticsEndDate,
    title,
  } = props;

  const handleDateApply = (start, end) => {
    setAnalyticsStartDate(start);
    setAnalyticsEndDate(end);
  };

  const handleDateClear = () => {
    setAnalyticsStartDate("All");
    setAnalyticsEndDate("All");
  };

  const isAll =
    !analyticsStartDate ||
    !analyticsStartEnd ||
    String(analyticsStartDate).toUpperCase() === "ALL" ||
    String(analyticsStartEnd).toUpperCase() === "ALL";

  return (
    <div className="d-flex m-2 align-items-center analytic-box flex-wrap gap-2">
      <DateRangeSelect
        startDate={isAll ? "All" : analyticsStartDate}
        endDate={isAll ? "All" : analyticsStartEnd}
        onApply={handleDateApply}
        onClear={handleDateClear}
        placeholder="Select Date"
      />
      {isAll ? (
        <div className="ms-3 fs-5 fw-normal title-name text-white">{title}</div>
      ) : (
        <div
          className="dateShow ms-3 fw-semibold"
          style={{ fontSize: "15px" }}
        >
          <span className="start-date">{analyticsStartDate}</span>
          <span className="mx-2 to-date"> To </span>
          <span className="end-date">{analyticsStartEnd}</span>
        </div>
      )}
    </div>
  );
};

export default Analytics;
